import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import { connect } from 'react-redux';
import {
  selectStartDate,
  selectEndDate,
  setReportFiltersDirty,
} from '../actions';
import Filters from './filters';
import { getReportFiltersDirty } from '../selectors';
import withDefaultEndingDate from './containers/withDefaultEndingDate';

const mapStateToProps = state => ({
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
  isFetching: Boolean(state.loadingBar),
  isDirty: getReportFiltersDirty(state),
});

const mapDispatchToProps = {
  selectStartDate,
  selectEndDate,
  setReportFiltersDirty,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('start', 'setStartDate', props => props.startDate),
  withState('end', 'setEndDate', props => props.endDate),
  withHandlers({
    submitDate: props => () => {
      props.selectStartDate(props.start);
      props.selectEndDate(props.end);

      if (props.submit) {
        // Give redux time to add dates to store
        setImmediate(props.submit);
      }
    },
    onDateChange: props => (from, to) => {
      props.setStartDate(from);
      props.setEndDate(to);
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.start !== this.props.start || prevProps.end !== this.props.end) {
        this.props.setReportFiltersDirty();
      }

      if (prevProps.startDate !== this.props.startDate) {
        this.props.setStartDate(this.props.startDate);
      }

      if (prevProps.endDate !== this.props.endDate) {
        this.props.setEndDate(this.props.endDate);
      }
    },
  }),
  withDefaultEndingDate(),
)(Filters);
